import { createGlobalStyle } from 'styled-components';

export const AppStyled = createGlobalStyle`
  ${({ theme }) => theme.global};
`;
